<span [ngClass]="{ 'nav-fixed': !static }">
	<sb-top-nav [multitenant]="multitenant"></sb-top-nav>
	@if (multitenant) {
		<div id="layoutSidenav">
			<div id="layoutSidenav_content" [ngClass]="{ scrollable: !static }" style="padding-left: 0 !important; margin-left: 0 !important;">
				<main>
					<ng-container *ngTemplateOutlet="defaultContent"></ng-container>
				</main>
				<sb-footer></sb-footer>
			</div>
		</div>
	} @else {
		<div id="layoutSidenav">
			<!-- Modo app (spec 058): o menu inferior substitui o lateral, e o rodapé some. -->
			@if (!appNative) {
				<div id="layoutSidenav_nav">
					<sb-side-nav [sidenavStyle]="sidenavStyle"
								 [sideNavItems]="_sideNavItems"
								 [sideNavSections]="_sideNavSections">
					</sb-side-nav>
				</div>
			}
			<div id="layoutSidenav_content" class="custom-scroll-container"
				 [ngClass]="{ scrollable: !static }"
				 (click)="closeSideNavIfOpen()">
				<main>
					<ng-container *ngTemplateOutlet="defaultContent"></ng-container>
				</main>
				@if (!appNative) {
					<sb-footer></sb-footer>
				}
			</div>
		</div>
		@if (appNative) {
			<sb-bottom-nav></sb-bottom-nav>
		}
	}
</span>
<ng-template #defaultContent>
	<ng-content></ng-content>
</ng-template>
